import {
  Box,
  Flex,
  Modal,
  Typography,
  useMobileMediaQuery,
} from '@iheartjane/reefer';
import type { ColorKey } from '@iheartjane/reefer';
import type { ReactNode } from 'react';

import { DeselectAllButton } from './deselectAllButton';

export const CONTENT_DIVIDER_PROPS = {
  color: 'grays-ultralight' as ColorKey,
  height: 16,
  padding: false,
};
interface ModalSectionProps {
  children: ReactNode;
  onDeselectClick?: () => void;
  title: string;
}

export const ModalSection = ({
  children,
  onDeselectClick,
  title,
}: ModalSectionProps) => {
  const isMobile = useMobileMediaQuery({});

  return (
    <Box width="100%">
      <Modal.ContentDivider {...CONTENT_DIVIDER_PROPS} />
      <Flex flexDirection="column" p={isMobile ? 24 : 40}>
        <Flex justifyContent="space-between" mb={16}>
          <Typography
            variant={isMobile ? 'body' : 'header-bold'}
            branded={!isMobile}
          >
            {title}
          </Typography>
          {onDeselectClick && (
            <DeselectAllButton
              onClick={onDeselectClick}
              ariaLabel={`Deselect all ${title} filters`}
            />
          )}
        </Flex>
        {children && (
          <Flex flexWrap="wrap" gap={16}>
            {children}
          </Flex>
        )}
      </Flex>
    </Box>
  );
};
